import React from 'react';
import { RHFTextField } from '@talentmesh/forms';
import ApplicantInformationType from '../../../../../../Models/ApplicantInformationType';
import useTMTranslation from '../../../../../../Hooks/useTMTranslation';

function NoticePeriod(): React.JSX.Element {
    const { tCommon: t } = useTMTranslation();

    return <RHFTextField fullWidth label={`${t('NoticePeriod')}*`} name={ApplicantInformationType.NoticePeriod} />;
}

export default NoticePeriod;
